import "./polyfills";
// Before anything that makes an axios instance: recovers a device whose
// location moved ("This device has switched location").
import "./_utils/siteSwitchGuard";
import React from "react";
import ReactDOM from "react-dom";
import { PersistGate } from "redux-persist/integration/react";
import "bootstrap/dist/css/bootstrap.min.css";
// Font Awesome 4.7 — locally bundled replacement for the old render-blocking
// maxcdn.bootstrapcdn.com <link> that used to live in public/index.html.
// Exact same version, exact same class names ("fa fa-heart" etc.) so every
// existing usage across ~300 spots keeps working without refactor. Imported
// here (not via CDN) so it lands in the CRA build output and is served from
// Capacitor's local bundle directory — no cold-start DNS/TLS round-trip.
import "font-awesome/css/font-awesome.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "./index.css";
import { Routes } from "./routes";
import { Provider } from "react-redux";

import * as serviceWorker from "./serviceWorker";
import { store, persistor } from "./config/store";
import { hideSplashScreen } from "./_services/splashScreen";
import "./component/notifications/devSeed";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import { hotjar } from "react-hotjar";

console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);

// Purge stale Redux state when switching environments (e.g. dev -> staging)
const currentEnv = process.env.REACT_APP_ENV || 'dev';
const storedEnv = localStorage.getItem('REACT_APP_ENV');
if (storedEnv && storedEnv !== currentEnv) {
  console.log(`Environment changed from ${storedEnv} to ${currentEnv}, clearing stale state`);
  persistor.purge();
  localStorage.removeItem('accessToken');
  localStorage.removeItem('persist:root');
}
localStorage.setItem('REACT_APP_ENV', currentEnv);

const advancedMatching = { em: "charlie@beuapp.com" }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: true, // enable logs 
};

if (
  process.env.REACT_APP_ENV === "prod" ||
  process.env.REACT_APP_ENV === "production"
) {
  ReactGA.initialize("UA-113180641-1");
  ReactGA.pageview(window.location.pathname + window.location.search);
  ReactPixel.init("3242802232608550", advancedMatching, options);
  hotjar.initialize(1902336, 6);
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Routes />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// Safety-net: hide the native Capacitor splash screen after 3 seconds no
// matter what. The marketplace homepage hides it earlier (as soon as home
// data paints), but if a user cold-starts on /login, /salon/:id, /signup,
// etc., there's no home-data signal to hook. This ensures they never get
// stuck on the splash. No-op on web.
setTimeout(() => {
  hideSplashScreen();
}, 3000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
